// Copyright (C) 2025 Skylark Drones

import BaseApi from './baseHttpApi'
import { BASE_API_HOST_URL } from '@/constants'

export default class NoVersionApi extends BaseApi {
  whitelistURLs = []

  constructor() {
    super('api', BASE_API_HOST_URL)
  }
}
